import React, { useEffect, useId, useState } from "react";
import {
  Button,
  ListSubheader,
  Menu,
} from "@mui/material";

import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { useOpcoesFonte } from "./OpcoesFonte";
import { tamanhosControlesGlobais } from "../estilos/global";
import Tooltip from "@mui/material/Tooltip";

export default function ControleFonte() {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();
  const idBotao = `controle-fonte-botao-${id}`;
  const idMenu = `controle-fonte-menu-${id}`;
  const aberto = Boolean(anchorEl);
  const fecharMenu = () => setAnchorEl(null);
  const { percentual, habilitado, itens } = useOpcoesFonte(fecharMenu);

  useEffect(() => {
    if (!habilitado) {
      setAnchorEl(null);
    }
  }, [habilitado]);

  if (!habilitado) {
    return null;
  }

  return (
    <>
      <Tooltip title={`Tamanho da fonte: ${percentual}%`} arrow>
        <Button
          id={idBotao}
          type="button"
          variant="outlined"
          color="inherit"
          aria-label={`Tamanho da fonte: ${percentual}%. Abrir opções`}
          aria-controls={aberto ? idMenu : undefined}
          aria-haspopup="menu"
          aria-expanded={aberto}
          
          onClick={(event) => setAnchorEl(event.currentTarget)}
          endIcon={
            <ArrowDropDownRoundedIcon
              aria-hidden="true"
              sx={{ fontSize: "18px !important" }}
            />
          }
          sx={{
            minWidth: 60,
            minHeight: 44,
            px: 1.25,
            borderRadius: 1,
            flexShrink: 0,
            fontSize: tamanhosControlesGlobais.botao,
            fontWeight: 500,
            textTransform: "none",
            whiteSpace: "nowrap",
            "& .MuiButton-endIcon": {
              ml: 0.5,
            },
          }}
        >
          Aa
        </Button>
      </Tooltip>

      <Menu
        id={idMenu}
        anchorEl={anchorEl}
        open={aberto}
        onClose={fecharMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          "aria-labelledby": idBotao,
          sx: { p: 1 },
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.75,
              width: "max-content",
              minWidth: 224,
              maxWidth: "calc(100vw - 32px)",
              borderRadius: 1.5,
              border: "1px solid",
              borderColor: "divider",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
            },
          },
        }}
      >
        <ListSubheader
          component="div"
          disableSticky
          sx={{
            px: 1.25,
            py: 0.75,
            bgcolor: "transparent",
            color: "text.primary",
            fontSize: tamanhosControlesGlobais.botao,
            fontWeight: 700,
            lineHeight: 1.5,
          }}
        >
          Tamanho da fonte
        </ListSubheader>

        {itens}
      </Menu>
    </>
  );
}
